/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingData
 */
export interface FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingData {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingData
     */
    Token: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingData
     */
    DeveloperPayload: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingData
     */
    Sku: string;
}

/**
 * Check if a given object implements the FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingData interface.
 */
export function instanceOfFxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingData(value: object): value is FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingData {
    if (!('Token' in value) || value['Token'] === undefined) return false;
    if (!('DeveloperPayload' in value) || value['DeveloperPayload'] === undefined) return false;
    if (!('Sku' in value) || value['Sku'] === undefined) return false;
    return true;
}

export function FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingDataFromJSON(json: any): FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingData {
    return FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingDataFromJSONTyped(json, false);
}

export function FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingData {
    if (json == null) {
        return json;
    }
    return {
        
        'Token': json['Token'],
        'DeveloperPayload': json['DeveloperPayload'],
        'Sku': json['Sku'],
    };
}

export function FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingDataToJSON(json: any): FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingData {
    return FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingDataToJSONTyped(json, false);
}

export function FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingDataToJSONTyped(value?: FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Token': value['Token'],
        'DeveloperPayload': value['DeveloperPayload'],
        'Sku': value['Sku'],
    };
}

